cb.define(function () {
  var common_VM_Extend = function () {
    var processRegionDisplay = function (rCodeModel, regionDisplayModel) {
      if (!rCodeModel || !regionDisplayModel.getState('dataSourceReady')) return;
      var rCode = rCodeModel.getValue();
      var value = [];
      var value2 = [];
      while (rCode != undefined && rCode != "") {
        value.push(rCode);
        var nodes = regionDisplayModel.getNodesByKeys(rCode);
        if (nodes != undefined && nodes.length > 0) {
          rCode = nodes[0].parent;
        } else {
          rCode = "";
        }
      }
      if (value.length > 0) {
        for (var i = 1; i <= value.length; i++) {
          value2.push(value[value.length - i]);
        }
      }
      regionDisplayModel.setValue(value2);
    }
    var getRegionCodeModel = function (viewModel) {
      var model = viewModel.get('regionCode');
      if (model instanceof cb.models.FilterModel)
        model = model.getFromModel();
      return model;
    }
    var initRegionAndPosition = function (viewmodel) {
      var changeOnSelect = viewmodel.get('regionCode') ? false : true;
      var regionDisplayModel = new cb.models.TreeModel({
        keyField: 'id',
        titleField: 'name',
        dataSourceMode: 'remote',
        needCollect: false,
        changeOnSelect: changeOnSelect
      }); //, needConvert: true

      // 处理行政区划信息regionCode 地区代码 regionDisplay 地区代码展现
      viewmodel.addProperty('region', regionDisplayModel);
      regionDisplayModel.setDataSource({
        url: '/region/getAllregion',
        method: 'POST'
      });
      regionDisplayModel.on('afterSetDataSource', function (data) {
        regionDisplayModel.setState('dataSourceReady', true);
        processRegionDisplay(getRegionCodeModel(viewmodel), regionDisplayModel);
      });
      regionDisplayModel.on('afterValueChange', function (result) {
        var rCodeModel = getRegionCodeModel(viewmodel);
        if (result && result.value.length) {
          var mergername = result.value[result.value.length - 1].mergername;
          var rCode = '';
          rCode = result.value[result.value.length - 1].id; //根据result.value和regionDisplayModel的数值，计算rCode的数值
          rCodeModel.setValue(rCode);
        } else {
          rCodeModel.setValue(null);
        }
      });

      // 处理定位信息 position 定位   address 详细地址    latitude 纬度    longitude 经度
      var positionModel = new cb.models.SimpleModel({
        needCollect: false
      }); //显示控件为Map
      viewmodel.addProperty('position', positionModel);

      viewmodel.on('afterLoadData', function () {
        processRegionDisplay(getRegionCodeModel(viewmodel), regionDisplayModel);
        var latitude = viewmodel.get('latitude').getValue();
        var longitude = viewmodel.get('longitude').getValue();
        var address = viewmodel.get('address').getValue();
        positionModel.setValue({
          latitude: latitude,
          longitude: longitude,
          address: address
        });
      });
      positionModel.on('afterValueChange', function (args) {
        viewmodel.get('latitude').setValue(args.value.latitude);
        viewmodel.get('longitude').setValue(args.value.longitude);
        viewmodel.get('address').setValue(args.value.address);
      });
    }
    var bacthnoAndExpiryDateManage = function (args, detailsModel) {
      var currentRow = detailsModel.getRow(args.value.rowIndex);
      //如果商品未启用批次管理，那么批次号不可编辑
      if (args.value.columnKey == 'batchno' || args.value.columnKey == 'define1' || args.value.columnKey == 'define2' || args.value.columnKey == 'define3' ||
        args.value.columnKey == 'define4' || args.value.columnKey == 'define5' || args.value.columnKey == 'define6' || args.value.columnKey == 'define7' ||
        args.value.columnKey == 'define8' || args.value.columnKey == 'define9' || args.value.columnKey == 'define10' || args.value.columnKey == 'define11' ||
        args.value.columnKey == 'define12' || args.value.columnKey == 'define13' || args.value.columnKey == 'define14' || args.value.columnKey == 'define15' ||
        args.value.columnKey == 'define16' || args.value.columnKey == 'define17' || args.value.columnKey == 'define18' || args.value.columnKey == 'define19' ||
        args.value.columnKey == 'define20' || args.value.columnKey == 'define21' || args.value.columnKey == 'define22' || args.value.columnKey == 'define23' ||
        args.value.columnKey == 'define24' || args.value.columnKey == 'define25' || args.value.columnKey == 'define26' || args.value.columnKey == 'define27' ||
        args.value.columnKey == 'define28' || args.value.columnKey == 'define29' || args.value.columnKey == 'define30') {
        if (currentRow.isBatchManage == true) {
//        detailsModel.setCellState(args.value.rowIndex, 'batchno', 'bIsNull', false);
        } else {
          return false;
        }
      }
      //如果商品未启用批次管理和效期管理，那么生效日期和失效日期不可编辑
      if (args.value.columnKey == 'producedate' || args.value.columnKey == 'invaliddate') {
        if (currentRow.isBatchManage == true && currentRow.isExpiryDateManage == true) {
//        detailsModel.setCellState(args.value.rowIndex, 'producedate', 'bIsNull', false);
//        detailsModel.setCellState(args.value.rowIndex, 'invaliddate', 'bIsNull', false);
        } else {
          return false;
        }
      }
    };

    var initBarcodeModel = function (viewmodel) {
      viewmodel.addProperty("barcode", new cb.models.SimpleModel({
        "cFieldName": "barcode",
        "cItemName": "barcode",
        "iMaxLength": 255,
        "iFieldType": 1,
        "bEnum": false,
        "bMustSelect": false,
        "bHidden": true,
        "bSplit": false,
        "bExtend": false,
        "bCanModify": true,
        "iMaxShowLen": 255,
        "bNeedSum": false,
        "bShowIt": false,
        "bFilter": true,
        "bIsNull": true,
        "bPrintCaption": true,
        "bJointQuery": false,
        "bPrintUpCase": false,
        "bSelfDefine": false,
        "bMain": false,
        "cControlType": "Input"
      }));
    };

    var onBarCodeEnter = function (data, viewmodel, fields, AfterBarcodeEnterCallback) {
      debugger;
      //cb.utils.alert('barcode enter');
      var curMainId = viewmodel.get("id").getValue();
      var curIuputValue = data ? data : viewmodel.get("barcode").getValue();
      // var detailsModel = viewmodel.get("details");//new 
      if (!viewmodel.getGridModels()) {
        return;
      }
      var detailsModel = null;
      var qtyField = 'quantity';
      var detailsModel;

      var newRow = function (mainid, data, quantity, fields) {
        let pData = data.data.recordList[0];
        let isBatchManage = pData.isBatchManage;
        let accountWeight = null;
        let batchno = null;
        let producedate = null;
        let invaliddate = null;
        let weight = null;

        if (!isBatchManage) {
          accountWeight = pData.productskus[0].sku_define1;
          weight = accountWeight;
        } else {
          batchno = pData.productskus[0].batchno;

          if (null != batchno && batchno != undefined) {
            producedate = pData.productskus[0].producedate;
            invaliddate = pData.productskus[0].invaliddate;
            let define1 = pData.productskus[0].batchno_define1;

            accountWeight = define1;
            weight = define1;
          }
        }
        if (!fields) {
          fields = {
            mainid: 'mainid',
            product: 'product',
            productcode: 'product_cCode',
            productname: 'product_cName',
            productsku: 'productsku',
            barcode: 'barcode',
            batchno: 'batchno',
            producedate: 'producedate',
            invaliddate: 'invaliddate',
            productskucode: 'productsku_cCode',
            weight: 'weight',
            quantity: 'quantity',
            unit: 'unit',
            unitname: 'product_unitName',//'unitName',
            // "accountWeight": 'accountWeight',
            // "accountPrice": pData.productskus[0].skuSalePrice,
            isbatch: 'isBatchManage'
          };
        }
        var rowObj = {};
        rowObj[fields.mainid] = mainid;
        rowObj[fields.product] = pData.productskus[0].product;
        rowObj[fields.productcode] = pData.cCode;
        rowObj[fields.productname] = pData.cName;
        rowObj[fields.productsku] = pData.productskus[0].skuId;
        rowObj[fields.barcode] = pData.productskus[0].barCode;
        rowObj[fields.batchno] = batchno;
        rowObj[fields.producedate] = producedate;
        rowObj[fields.invaliddate] = invaliddate;
        rowObj[fields.productskucode] = pData.productskus[0].skuCode;
        rowObj[fields.weight] = weight;
        rowObj[fields.quantity] = quantity;
        rowObj[fields.unit] = pData.oUnitId;
        rowObj[fields.unitname] = pData.unitName;
        // "accountWeight": accountWeight,
        // "accountPrice": pData.productskus[0].skuSalePrice,
        rowObj[fields.isbatch] = isBatchManage;

        let dataProductsku = pData.productskus[0];
        // ====== 自由项 ======
        for (let i = 1; i <= 10; i++) {
          let free = 'free' + i.toString();
          rowObj[free] = dataProductsku[free] ? dataProductsku[free] : null;
        }
        // ====== 批次属性 ======
        for (let i = 1; i <= 30; i++) {
          let define = 'define' + i.toString();
          rowObj[define] = dataProductsku['batchno_' + define] ? dataProductsku['batchno_' + define] : null;
        }
        // ====== 商品自定义项 ======
        for (let i = 1; i <= 30; i++) {
          let prodefine = 'prodefine' + i.toString();
          rowObj[prodefine] = pData['define' + i.toString()] ? dataProductsku['define' + i.toString()] : null;
        }
        // ====== SKU自定义项 ======
        for (let i = 1; i <= 60; i++) {
          let skudefine = 'skudefine' + i.toString();
          rowObj[skudefine] = dataProductsku['sku_define' + define] ? dataProductsku['sku_define' + define] : null;
        }


        return rowObj;
      };//newRow end

      var findRow = function (detailsModel, productsku, isBatchManage, batchNo = '_invalid_value_') {
        var rowIndex = -1;
        var rows = detailsModel.getRows();
        var rowLength = rows.length;

        for (var i = 0; i < rowLength; i++) {
          if (rows[i]._status == 'Delete') {
            continue;
          }

          if (productsku == detailsModel.getCellValue(i, fields.productsku)) {
            if (isBatchManage) {
              if (batchNo == detailsModel.getCellValue(i, fields.batchno)) {
                rowIndex = i;
                break;
              } else {
                if (batchNo == '_invalid_value_') {
                  rowIndex = i;
                }
              }
            } else {
              if (detailsModel.getCellValue(i, fields.batchno) == undefined) {
                rowIndex = i;
                break;
              }
            }
          }
        }

        return rowIndex;
      };

      //更新行上数量
      var updateRowQty = function (detailsModel, curRowIndex, qtyField) {
        let newQuantity = null;
        let tempQty = detailsModel.getCellValue(curRowIndex, qtyField);
        if (null == tempQty || tempQty === undefined) {
          newQuantity = 1;
        } else {
          newQuantity = parseInt(tempQty) + 1;
        }
        detailsModel.setCellValue(curRowIndex, qtyField, newQuantity, false, false);
      }
      //新增行
      var appendNewRow = function (mainid, data, quantity = 1) {
        detailsModel.appendRow(newRow(mainid, data, quantity, fields));
      };

      var updateCurrentRow = function (curRowIndex, mainid, data, quantity = 1) {
        detailsModel.updateRow(curRowIndex, newRow(mainid, data, quantity, fields));
      };

      var getDetailModelByName = function (name) {
        for (let i = 0; i < viewmodel.getGridModels().length; i++) {
          if (name === viewmodel.getGridModels()[i].getName()) {
            detailsModel = viewmodel.getGridModels()[i];
            break;
          }
        }
        console.log('未找到对应的GridModel,请检查名称是否正确!');
      };

      if (viewmodel.getGridModels().length == 1) {
        detailsModel = viewmodel.getGridModel();
      } else {

        // if (viewmodel.get('barcode').getParent() === viewmodel.getGridModels()[i].getParent()) {
        if (viewmodel.originalViewMeta.cBillNo == 'st_storeout') {
          detailsModel = getDetailModelByName('details');
        }
        //增加其他单据判断 ...
        //}else if(){
        else {
          detailsModel = viewmodel.getGridModels()[0];
        }
      }

      var queryProductProxy = cb.rest.DynamicProxy.create({
        settle: {
          //url: '/bill/ref/getProducts.do',
          url: '/bill/ref/getBarcodeResult.do',
          method: 'POST'
        }
      });
      var params = {
        isReturn: 0,
        keyword: curIuputValue

      };

      if (curIuputValue && detailsModel) {
        queryProductProxy.settle(params, (err, result) => {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }

          if (result === undefined || JSON.stringify(result) == "{}") {
            cb.utils.alert("没有条码为[" + curIuputValue + "]的商品！", 'error');
            return;
          }

          let pData = result.data.recordList[0];
          let isBatchManage = pData.isBatchManage;
          let resultSku = pData.productskus["0"].skuId;
          let batchno = isBatchManage ? pData.productskus[0].batchno : "_invalid_value_";

          let curRowIndex = detailsModel.getSelectedRowIndexes()[0];
          if (curRowIndex === undefined) {
            // ====== 未选择任何表体行 ======
            var targetRow = findRow(detailsModel, resultSku, isBatchManage, batchno);

            if (targetRow != -1) {
              curRowIndex = targetRow;
              updateRowQty(detailsModel, curRowIndex, qtyField);
            } else {
              appendNewRow(curMainId, result);
              curRowIndex = detailsModel.getRows().length - 1;
            }


          } else {
            // ====== 当前选择了一行 ======
            //let curRow = detailsModel.getRow(curRowIndex);

            if (detailsModel.getCellValue(curRowIndex, fields.productsku) === resultSku &&
              (isBatchManage ? (detailsModel.getCellValue(curRowIndex, fields.batchno) === batchno ? true : false) : true)) {
              updateRowQty(detailsModel, curRowIndex, qtyField);
            } else if (detailsModel.getCellValue(curRowIndex, fields.productsku) === undefined ||
              detailsModel.getCellValue(curRowIndex, fields.productsku) === null) {
              updateCurrentRow(curRowIndex, curMainId, result);
            } else {
              var targetRow = findRow(detailsModel, resultSku, isBatchManage, batchno);

              if (targetRow != -1) {
                curRowIndex = targetRow;
                updateRowQty(detailsModel, curRowIndex, qtyField);
              } else {
                appendNewRow(curMainId, result);
                curRowIndex = detailsModel.getRows().length - 1;
              }

            }
          }

          if (AfterBarcodeEnterCallback) AfterBarcodeEnterCallback(result);
        });
      }
      viewmodel.get("barcode").setValue(null);
    };


    var strChineseFirstPY = "YDYQSXMWZSSXJBYMGCCZQPSSQBYCDSCDQLDYLYBSSJGYZZJJFKCCLZDHWDWZJLJPFYYNWJJTMYHZWZHFLZPPQHGSCYYYNJQYXXGJHHSDSJNKKTMOMLCRXYPSNQSECCQZGGLLYJLMYZZSECYKYYHQWJSSGGYXYZYJWWKDJHYCHMYXJTLXJYQBYXZLDWRDJRWYSRLDZJPCBZJJBRCFTLECZSTZFXXZHTRQHYBDLYCZSSYMMRFMYQZPWWJJYFCRWFDFZQPYDDWYXKYJAWJFFXYPSFTZYHHYZYSWCJYXSCLCXXWZZXNBGNNXBXLZSZSBSGPYSYZDHMDZBQBZCWDZZYYTZHBTSYYBZGNTNXQYWQSKBPHHLXGYBFMJEBJHHGQTJCYSXSTKZHLYCKGLYSMZXYALMELDCCXGZYRJXSDLTYZCQKCNNJWHJTZZCQLJSTSTBNXBTYXCEQXGKWJYFLZQLYHYXSPSFXLMPBYSXXXYDJCZYLLLSJXFHJXPJBTFFYABYXBHZZBJYZLWLCZGGBTSSMDTJZXPTHYQTGLJSCQFZKJZJQNLZWLSLHDZBWJNCJZYZSQQYCQYRZCJJWYBRTWPYFTWEXCSKDZCTBZHYZZYYJXZCFFZZMJYXXSDZZOTTBZLQWFCKSZSXFYRLNYJMBDTHJXSQQCCSBXYYTSYFBXDZTGBCNSLCYZZPSAZYZZSCJCSHZQYDXLBPJLLMQXTYDZXSQJTZPXLCGLQTZWJBHCTSYJSFXYEJJTLBGXSXJMYJQQPFZASYJNTYDJXKJCDJSZCBARTDCLYJQMWNQNCLLLKBYBZZSYHQQLTWLCCXTXLLZNTYLNEWYZYXCZXXGRKRMTCNDNJTSYYSSDQDGHSDBJGHRWRQLYBGLXHLGTGXBQJDZPYJSJYJCTMRNYMGRZJCZGJMZMGXMPRYXKJNYMSGMZJYMKMFXMLDTGFBHCJHKYLPFMDXLQJJSMTQGZSJLQDLDGJYCALCMZCSDJLLNXDJFFFFJCZFMZFFPFKHKGDPSXKTACJDHHZDDCRRCFQYJKQCCWJDXHWJLYLLZGCFCQDSMLZPBJJPLSBCJGGDCKKDEZSQCCKJGCGKDJTJDLZYCXKLQSCGJCLTFPCQCZGWPJDQYZJJBYJHSJDZWGFSJGZKQCCZLLPSPKJGQJHZZLJPLGJGJJTHJJYJZCZMLZLYQBGJWMLJKXZDZNJQSYZMLJLLJKYWXMKJLHSKJGBMCLYYMKXJQLBMLLKMDXXKWYXYSLMLPSJQQJQXYXFJTJDXMXXLLCXQBSYJBGWYMBGGBCYXPJYGPEPFGDJGBHBNSQJYZJKJKHXQFGQZKFHYGKHDKLLSDJQXPQYKYBNQSXQNSZSWHBSXWHXWBZZXDMNSJBSBKBBZKLYLXGWXDRWYQZMYWSJQLCJXXJXKJEQXSCYETLZHLYYYSDZPAQYZCMTLSHTZCFYZYXYLJSDCJQAGYSLCQLYYYSHMRQQKLDXZSCSSSYDYCJYSFSJBFRSSZQSBXXPXJYSDRCKGJLGDKZJZBDKTCSYQPYHSTCLDJDHMXMCGXYZHJDDTMHLTXZXYLYMOHYJCLTYFBQQXPFBDFHHTKSQHZYYWCNXXCRWHOWGYJLEGWDQCWGFJYCSNTMYTOLBYGWQWESJPWNMLRYDZSZTXYQPZGCWXHNGPYXSHMYQJXZTDPPBFYHZHTJYFDZWKGKZBLDNTSXHQEEGZZYLZMMZYJZGXZXKHKSTXNXXWYLYAPSTHXDWHZYMPXAGKYDXBHNHXKDPJNMYHYLPMGOCSLNZHKXXLPZZLBMLSFBHHGYGYYGGBHSCYAQTYWLXTZQCEZYDQDQMMHTKLLSZHLSJZWFYHQSWSCWLQAZYNYTLSXTHAZNKZZSZZLAXXZWWCTGQQTDDYZTCCHYQZFLXPSLZYGPZSZNGLNDQTBDLXGTCTAJDKYWNSYZLJHHZZCWNYYZYWMHYCHHYXHJKZWSXHZYXLYSKQYSPSLYZWMYPPKBYGLKZHTYXAXQSYSHXASMCHKDSCRSWJPWXSGZJLWWSCHSJHSQNHCSEGNDAQTBAALZZMSSTDQJCJKTSCJAXPLGGXHHGXXZCXPDMMHLDGTYBYSJMXHMRCPXXJZCKZXSHMLQXXTTHXWZFKHCCZDYTCJYXQHLXDHYPJQXYLSYYDZOZJNYXQEZYSQYAYXWYPDGXDDXSPPYZNDLTWRHXYDXZZJHTCXMCZLHPYYYYMHZLLHNXMYLLLMDCPPXHMXDKYCYRDLTXJCHHZZXZLCCLYLNZSHZJZZLNNRLWHYQSNJHXYNTTTKYJPYCHHYEGKCTTWLGQRLGGTGTYGYHPYHYLQYQGCWYQKPYYYTTTTLHYHLLTYTTSPLKYZXGZWGPYDSSZZDQXSKCQNMJJZZBXYQMJRTFFBTKHZKBXLJJKDXJTLBWFZPPTKQTZTGPDGNTPJYFALQMKGXBDCLZFHZCLLLLADPMXDJHLCCLGYHDZFGYDDGCYYFGYDXKSSEBDHYKDKDKHNAXXYBPBYYHXZQGAFFQYJXDMLJCSQZLLPCHBSXGJYNDYBYQSPZWJLZKSDDTACTBXZDYZYPJZQSJNKKTKNJDJGYYPGTLFYQKASDNTCYHBLWDZHBBYDWJRYGKZYHEYYFJMSDTYFZJJHGCXPLXHLDWXXJKYTCYKSSSMTWCTTQZLPBSZDZWZXGZAGYKTYWXLHLSPBCLLOQMMZSSLCMBJCSZZKYDCZJGQQDSMCYTZQQLWZQZXSSFPTTFQMDDZDSHDTDWFHTDYZJYQJQKYPBDJYYXTLJHDRQXXXHAYDHRJLKLYTWHLLRLLRCXYLBWSRSZZSYMKZZHHKYHXKSMDSYDYCJPBZBSQLFCXXXNXKXWYWSDZYQOGGQMMYHCDZTTFJYYBGSTTTYBYKJDHKYXBELHTYPJQNFXFDYKZHQKZBYJTZBXHFDXKDASWTAWAJLDYJSFHBLDNNTNQJTJNCHXFJSRFWHZFMDRYJYJWZPDJKZYJYMPCYZNYNXFBYTFYFWYGDBNZZZDNYTXZEMMQBSQEHXFZMBMFLZZSRXYMJGSXWZJSPRYDJSJGXHJJGLJJYNZZJXHGXKYMLPYYYCXYTWQZSWHWLYRJLPXSLSXMFSWWKLCTNXNYNPSJSZHDZEPTXMYYWXYYSYWLXJQZQXZDCLEEELMCPJPCLWBXSQHFWWTFFJTNQJHJQDXHWLBYZNFJLALKYYJLDXHHYCSTYYWNRJYXYWTRMDRQHWQCMFJDYZMHMYYXJWMYZQZXTLMRSPWWCHAQBXYGZYPXYYRRCLMPYMGKSJSZYSRMYJSNXTPLNBAPPYPYLXYYZKYNLDZYJZCZNNLMZHHARQMPGWQTZMXXMLLHGDZXYHXKYXYCJMFFYYHJFSBSSQLXXNDYCANNMTCJCYPRRNYTYQNYYMBMSXNDLYLYSLJRLXYSXQMLLYZLZJJJKYZZCSFBZXXMSTBJGNXYZHLXNMCWSCYZYFZLXBRNNNYLBNRTGZQYSATSWRYHYJZMZDHZGZDWYBSSCSKXSYHYTXXGCQGXZZSHYXJSCRHMKKBXCZJYJYMKQHZJFNBHMQHYSNJNZYBKNQMCLGQHWLZNZSWXKHLJHYYBQLBFCDSXDLDSPFZPSKJYZWZXZDDXJSMMEGJSCSSMGCLXXKYYYLNYPWWWGYDKZJGGGZGGSYCKNJWNJPCXBJJTQTJWDSSPJXZXNZXUMELPXFSXTLLXCLJXJJLJZXCTPSWXLYDHLYQRWHSYCSQYYBYAYWJJJQFWQCQQCJQGXALDBZZYJGKGXPLTZYFXJLTPADKYQHPMATLCPDCKBMTXYBHKLENXDLEEGQDYMSAWHZMLJTWYGXLYQZLJEEYYBQQFFNLYXRDSCTGJGXYYNKLLYQKCCTLHJLQMKKZGCYYGLLLJDZGYDHZWXPYSJBZKDZGYZZHYWYFQYTYZSZYEZZLYMHJJHTSMQWYZLKYYWZCSRKQYTLTDXWCTYJKLWSQZWBDCQYNCJSRSZJLKCDCDTLZZZACQQZZDDXYPLXZBQJYLZLLLQDDZQJYJYJZYXNYYYNYJXKXDAZWYRDLJYYYRJLXLLDYXJCYWYWNQCCLDDNYYYNYCKCZHXXCCLGZQJGKWPPCQQJYSBZZXYJSQPXJPZBSBDSFNSFPZXHDWZTDWPPTFLZZBZDMYYPQJRSDZSQZSQXBDGCPZSWDWCSQZGMDHZXMWWFYBPDGPHTMJTHZSMMBGZMBZJCFZWFZBBZMQCFMBDMCJXLGPNJBBXGYHYYJGPTZGZMQBQTCGYXJXLWZKYDPDYMGCFTPFXYZTZXDZXTGKMTYBBCLBJASKYTSSQYYMSZXFJEWLXLLSZBQJJJAKLYLXLYCCTSXMCWFKKKBSXLLLLJYXTYLTJYYTDPJHNHNNKBYQNFQYYZBYYESSESSGDYHFHWTCJBSDZZTFDMXHCNJZYMQWSRYJDZJQPDQBBSTJGGFBKJBXTGQHNGWJXJGDLLTHZHHYYYYYYSXWTYYYCCBDBPYPZYCCZYJPZYWCBDLFWZCWJDXXHYHLHWZZXJTCZLCDPXUJCZZZLYXJJTXPHFXWPYWXZPTDZZBDZCYHJHMLXBQXSBYLRDTGJRRCTTTHYTCZWMXFYTWWZCWJWXJYWCSKYBZSCCTZQNHXNWXXKHKFHTSWOCCJYBCMPZZYKBNNZPBZHHZDLSYDDYTYFJPXYNGFXBYQXCBHXCPSXTYZDMKYSNXSXLHKMZXLYHDHKWHXXSSKQYHHCJYXGLHZXCSNHEKDTGZXQYPKDHEXTYKCNYMYYYPKQYYYKXZLTHJQTBYQHXBMYHSQCKWWYLLHCYYLNNEQXQWMCFBDCCMLJGGXDQKTLXKGNQCDGZJWYJJLYHHQTTTNWCHMXCXWHWSZJYDJCCDBQCDGDNYXZTHCQRXCBHZTQCBXWGQWYYBXHMBYMYQTYEXMQKYAQYRGYZSLFYKKQHYSSQYSHJGJCNXKZYCXSBXYXHYYLSTYCXQTHYSMGSCPMMGCCCCCMTZTASMGQZJHKLOSQYLSWTMXSYQKDZLJQQYPLSYCZTCQQPBBQJZCLPKHQZYYXXDTDDTSJCXFFLLCHQXMJLWCJCXTSPYCXNDTJSHJWXDQQJSKXYAMYLSJHMLALYKXCYYDMNMDQMXMCZNNCYBZKKYFLMCHCMLHXRCJJHSYLNMTJZGZGYWJXSRXCWJGJQHQZDQJDCJJZKJKGDZQGJJYJYLXZXXCDQHHHEYTMHLFSBDJSYYSHFYSTCZQLPBDRFRZTZYKYWHSZYQKWDQZRKMSYNBCRXQBJYFAZPZZEDZCJYWBCJWHYJBQSZYWRYSZPTDKZPFPBNZTKLQYHBBZPNPPTYZZYBQNYDCPJMMCYCQMCYFZZDCMNLFPBPLNGQJTBTTNJZPZBBZNJKLJQYLNBZQHKSJZNGGQSZZKYXSHPZSNBCGZKDDZQANZHJKDRTLZLSWJLJZLYWTJNDJZJHXYAYNCBGTZCSSQMNJPJYTYSWXZFKWJQTKHTZPLBHSNJZSYZBWZZZZLSYLSBJHDWWQPSLMMFBJDWAQYZTCJTBNNWZXQXCDSLQGDSDPDZHJTQQPSWLYYJZLGYXYZLCTCBJTKTYCZJTQKBSJLGMGZDMCSGPYNJZYQYYKNXRPWSZXMTNCSZZYXYBYHYZAXYWQCJTLLCKJJTJHGDXDXYQYZZBYWDLWQCGLZGJGQRQZCZSSBCRPCSKYDZNXJSQGXSSJMYDNSTZTPBDLTKZWXQWQTZEXNQCZGWEZKSSBYBRTSSSLCCGBPSZQSZLCCGLLLZXHZQTHCZMQGYZQZNMCOCSZJMMZSQPJYGQLJYJPPLDXRGZYXCCSXHSHGTZNLZWZKJCXTCFCJXLBMQBCZZWPQDNHXLJCTHYZLGYLNLSZZPCXDSCQQHJQKSXZPBAJYEMSMJTZDXLCJYRYYNWJBNGZZTMJXLTBSLYRZPYLSSCNXPHLLHYLLQQZQLXYMRSYCXZLMMCZLTZSDWTJJLLNZGGQXPFSKYGYGHBFZPDKMWGHCXMSGDXJMCJZDYCABXJDLNBCDQYGSKYDQTXDJJYXMSZQAZDZFSLQXYJSJZYLBTXXWXQQZBJZUFBBLYLWDSLJHXJYZJWTDJCZFQZQZZDZSXZZQLZCDZFJHYSPYMPQZMLPPLFFXJJNZZYLSJEYQZFPFZKSYWJJJHRDJZZXTXXGLGHYDXCSKYSWMMZCWYBAZBJKSHFHJCXMHFQHYXXYZFTSJYZFXYXPZLCHMZMBXHZZSXYFYMNCWDABAZLXKTCSHHXKXJJZJSTHYGXSXYYHHHJWXKZXSSBZZWHHHCWTZZZPJXSNXQQJGZYZYWLLCWXZFXXYXYHXMKYYSWSQMNLNAYCYSPMJKHWCQHYLAJJMZXHMMCNZHBHXCLXTJPLTXYJHDYYLTTXFSZHYXXSJBJYAYRSMXYPLCKDUYHLXRLNLLSTYZYYQYGYHHSCCSMZCTZQXKYQFPYYRPFFLKQUNTSZLLZMWWTCQQYZWTLLMLMPWMBZSSTZRBPDDTLQJJBXZCSRZQQYGWCSXFWZLXCCRSZDZMCYGGDZQSGTJSWLJMYMMZYHFBJDGYXCCPSHXNZCSBSJYJGJMPPWAFFYFNXHYZXZYLREMZGZCYZSSZDLLJCSQFNXZKPTXZGXJJGFMYYYSNBTYLBNLHPFZDCYFBMGQRRSSSZXYSGTZRNYDZZCDGPJAFJFZKNZBLCZSZPSGCYCJSZLMLRSZBZZLDLSLLYSXSQZQLYXZLSKKBRXBRBZCYCXZZZEEYFGKLZLYYHGZSGZLFJHGTGWKRAAJYZKZQTSSHJJXDCYZUYJLZYRZDQQHGJZXSSZBYKJPBFRTJXLLFQWJHYLQTYMBLPZDXTZYGBDHZZRBGXHWNJTJXLKSCFSMWLSDQYSJTXKZSCFWJLBXFTZLLJZLLQBLSQMQQCGCZFPBPHZCZJLPYYGGDTGWDCFCZQYYYQYSSCLXZSKLZZZGFFCQNWGLHQYZJJCZLQZZYJPJZZBPDCCMHJGXDQDGDLZQMFGPSYTSDYFWWDJZJYSXYYCZCYHZWPBYKXRYLYBHKJKSFXTZJMMCKHLLTNYYMSYXYZPYJQYCSYCWMTJJKQYRHLLQXPSGTLYYCLJSCPXJYZFNMLRGJJTYZBXYZMSJYJHHFZQMSYXRSZCWTLRTQZSSTKXGQKGSPTGCZNJSJCQCXHMXGGZTQYDJKZDLBZSXJLHYQGGGTHQSZPYHJHHGYYGKGGCWJZZYLCZLXQSFTGZSLLLMLJSKCTBLLZZSZMMNYTPZSXQHJCJYQXYZXZQZCPSHKZZYSXCDFGMWQRLLQXRFZTLYSTCTMJCXJJXHJNXTNRZTZFQYHQGLLGCXSZSJDJLJCYDSJTLNYXHSZXCGJZYQPYLFHDJSBPCCZHJJJQZJQDYBSSLLCMYTTMQTBHJQNNYGKYRQYQMZGCJKPDCGMYZHQLLSLLCLMHOLZGDYYFZSLJCQZLYLZQJESHNYLLJXGJXLYSYYYXNBZLJSSZCQQCJYLLZLTJYLLZLLBNYLGQCHXYYXOXCXQKYJXXXYKLXSXXYQXCYKQXQCSGYXXYQXYGYTQOHXHXPYXXXULCYEYCHZZCBWQBBWJQZSCSZSSLZYLKDESJZWMYMCYTSDSXXSCJPQQSQYLYYZYCMDJDZYWCBTJSYDJKCYDDJLBDJJSODZYSYXQQYXDHHGQQYQHDYXWGMMMAJDYBBBPPBCMUUPLJZSMTXERXJMHQNUTPJDCBSSMSSSTKJTSSMMTRCPLZSZMLQDSDMJMQPNQDXCFYNBFSDQXYXHYAYKQYDDLQYYYSSZBYDSLNTFQTZQPZMCHDHCZCWFDXTMYQSPHQYYXSRGJCWTJTZZQMGWJJTJHTQJBBHWZPXXHYQFXXQYWYYHYSCDYDHHQMNMTMWCPBSZPPZZGLMZFOLLCFWHMMSJZTTDHZZYFFYTZZGZYSKYJXQYJZQBHMBZZLYGHGFMSHPZFZSNCLPBQSNJXZSLXXFPMTYJYGBXLLDLXPZJYZJYHHZCYWHJYLSJEXFSZZYWXKZJLUYDTMLYMQJPWXYHXSKTQJEZRPXXZHHMHWQPWQLYJJQJJZSZCPHJLCHHNXJLQWZJHBMZYXBDHHYPZLHLHLGFWLCHYYTLHJXCJMSCPXSTKPNHQXSRTYXXTESYJCTLSSLSTDLLLWWYHDHRJZSFGXTSYCZYNYHTDHWJSLHTZDQDJZXXQHGYLTZPHCSQFCLNJTCLZPFSTPDYNYLGMJLLYCQHYSSHCHYLHQYQTMZYPBYWRFQYKQSYSLZDQJMPXYYSSRHZJNYWTQDFZBWWTWWRXCWHGYHXMKMYYYQMSMZHNGCEPMLQQMTCWCTMMPXJPJJHFXYYZSXZHTYBMSTSYJTTQQQYYLHYNPYQZLCYZHZWSMYLKFJXLWGXYPJYTYSYXYMZCKTTWLKSMZSYLMPWLZWXWQZSSAQSYXYRHSSNTSRAPXCPWCMGDXHXZDZYFJHGZTTSBJHGYZSZYSMYCLLLXBTYXHBBZJKSSDMALXHYCFYGMQYPJYCQXJLLLJGSLZGQLYCJCCZOTYXMTMTTLLWTGPXYMZMKLPSZZZXHKQYSXCTYJZYHXSHYXZKXLZWPSQPYHJWPJPWXQQYLXSDHMRSLZZYZWTTCYXYSZZSHBSCCSTPLWSSCJCHNLCGCHSSPHYLHFHHXJSXYLLNYLSZDHZXYLSXLWZYKCLDYAXZCMDDYSPJTQJZLNWQPSSSWCTSTSZLBLNXSMNYYMJQBQHRZWTYYDCHQLXKPZWBGQYBKFCMZWPZLLYYLSZYDWHXPSBCMLJBSCGBHXLQHYRLJXYSWXWXZSLDFHLSLYNJLZYFLYJYCDRJLFSYZFSLLCQYQFGJYHYXZLYLMSTDJCYHBZLLNWLXXYGYYHSMGDHXXHHLZZJZXCZZZCYQZFNGWPYLCPKPYYPMCLQKDGXZGGWQBDXZZKZFBXXLZXJTPJPTTBYTSZZDWSLCHZHSLTYXHQLHYXXXYYZYSWTXZKHLXZXZPYHGCHKCFSYHUTJRLXFJXPTZTWHPLYXFCRHXSHXKYXXYHZQDXQWULHYHMJTBFLKHTXCWHJFWJCFPQRYQXCYYYQYGRPYWSGSUNGWCHKZDXYFLXXHJJBYZWTSXXNCYJJYMSWZJQRMHXZWFQSYLZJZGBHYNSLBGTTCSYBYXXWXYHXYYXNSQYXMQYWRGYQLXBBZLJSYLPSYTJZYHYZAWLRORJMKSCZJXXXYXCHDYXRYXXJDTSQFXLYLTSFFYXLMTYJMJUYYYXLTZCSXQZQHZXLYYXZHDNBRXXXJCTYHLBRLMBRLLAXKYLLLJLYXXLYCRYLCJTGJCMTLZLLCYZZPZPCYAWHJJFYBDYYZSMPCKZDQYQPBPCJPDCYZMDPBCYYDYCNNPLMTMLRMFMMGWYZBSJGYGSMZQQQZTXMKQWGXLLPJGZBQCDJJJFPKJKCXBLJMSWMDTQJXLDLPPBXCWRCQFBFQJCZAHZGMYKPHYYHZYKNDKZMBPJYXPXYHLFPNYYGXJDBKXNXHJMZJXSTRSTLDXSKZYSYBZXJLXYSLBZYSLHXJPFXPQNBYLLJQKYGZMCYZZYMCCSLCLHZFWFWYXZMWSXTYNXJHPYYMCYSPMHYSMYDYSHQYZCHMJJMZCAAGCFJBBHPLYZYLXXSDJGXDHKXXTXXNBHRMLYJSLTXMRHNLXQJXYZLLYSWQGDLBJHDCGJYQYCMHWFMJYBMBYJYJWYMDPWHXQLDYGPDFXXBCGJSPCKRSSYZJMSLBZZJFLJJJLGXZGYXYXLSZQYXBEXYXHGCXBPLDYHWETTWWCJMBTXCHXYQXLLXFLYXLLJLSSFWDPZSMYJCLMWYTCZPCHQEKCQBWLCQYDPLQPPQZQFJQDJHYMMCXTXDRMJWRHXCJZYLQXDYYNHYYHRSLSRSYWWZJYMTLTLLGTQCJZYABTCKZCJYCCQLJZQXALMZYHYWLWDXZXQDLLQSHGPJFJLJHJABCQZDJGTKHSSTCYJLPSWZLXZXRWGLDLZRLZXTGSLLLLZLYXXWGDZYGBDPHZPBRLWSXQBPFDWOFMWHLYPCBJCCLDMBZPBZZLCYQXLDOMZBLZWPDWYYGDSTTHCSQSCCRSSSYSLFYBFNTYJSZDFNDPDHDZZMBBLSLCMYFFGTJJQWFTMTPJWFNLBZCMMJTGBDZLQLPYFHYYMJYLSDCHDZJWJCCTLJCLDTLJJCPDDSQDSSZYBNDBJLGGJZXSXNLYCYBJXQYCBYLZCFZPPGKCXZDZFZTJJFJSJXZBNZYJQTTYJYHTYCZHYMDJXTTMPXSPLZCDWSLSHXYPZGTFMLCJTYCBPMGDKWYCYZCDSZZYHFLYCTYGWHKJYYLSJCXGYWJCBLLCSNDDBTZBSCLYZCZZSSQDLLMQYYHFSLQLLXFTYHABXGWNYWYYPLLSDLDLLBJCYXJZMLHLJDXYYQYTDLLLBUGBFDFBBQJZZMDPJHGCLGMJJPGAEHHBWCQXAXHHHZCHXYPHJAXHLPHJPGPZJQCQZGJJZZUZDMQYYBZZPHYHYBWHAZYJHYKFGDPFQSDLZMLJXKXGALXZDAGLMDGXMWZQYXXDXXPFDMMSSYMPFMDMMKXKSYZYSHDZKXSYSMMZZZMSYDNZZCZXFPLSTMZDNMXCKJMZTYYMZMZZMSXHHDCZJEMXXKLJSTLWLSQLYJZLLZJSSDPPMHNLZJCZYHMXXHGZCJMDHXTKGRMXFWMCGMWKDTKSXQMMMFZZYDKMSCLCMPCGMHSPXQPZDSSLCXKYXTWLWJYAHZJGZQMCSNXYYMMPMLKJXMHLMLQMXCTKZMJQYSZJSYSZHSYJZJCDAJZYBSDQJZGWZQQXFKDMSDJLFWEHKZQKJPEYPZYSZCDWYJFFMZZYLTTDZZEFMZLBNPPLPLPEPSZALLTYLKCKQZKGENQLWAGYXYDPXLHSXQQWQCQXQCLHYXXMLYCCWLYMQYSKGCHLCJNSZKPYZKCQZQLJPDMDZHLASXLBYDWQLWDNBQCRYDDZTJYBKBWSZDXDTNPJDTCTQDFXQQMGNXECLTTBKPWSLCTYQLPWYZZKLPYGZCQQPLLKCCYLPQMZCZQCLJSLQZDJXLDDHPZQDLJJXZQDXYZQKZLJCYQDYJPPYPQYKJYRMPCBYMCXKLLZLLFQPYLLLMBSGLCYSSLRSYSQTMXYXZQZFDZUYSYZTFFMZZSMZQHZSSCCMLYXWTPZGXZJGZGSJSGKDDHTQGGZLLBJDZLCBCHYXYZHZFYWXYZYMSDBZZYJGTSMTFXQYXQSTDGSLNXDLRYZZLRYYLXQHTXSRTZNGZXBNQQZFMYKMZJBZYMKBPNLYZPBLMCNQYZZZSJZHJCTZKHYZZJRDYZHNPXGLFZTLKGJTCTSSYLLGZRZBBQZZKLPKLCZYSSUYXBJFPNJZZXCDWXZYJXZZDJJKGGRSRJKMSMZJLSJYWQSKYHQJSXPJZZZLSNSHRNYPZTWCHKLPSRZLZXYJQXQKYSJYCZTLQZYBBYBWZPQDWWYZCYTJCJXCKCWDKKZXSGKDZXWWYYJQYYTCYTDLLXWKCZKKLCCLZCQQDZLQLCSFQCHQHSFSMQZZLNBJJZBSJHTSZDYSJQJPDLZCDCWJKJZZLPYCGMZWDJJBSJQZSYZYHHXJPBJYDSSXDZNCGLQMBTSFSBPDZDLZNFGFJGFSMPXJQLMBLGQCYYXBQKDJJQYRFKZTJDHCZKLBSDZCFJTPLLJGXHYXZCSSZZXSTJYGKGCKGYOQXJPLZPBPGTGYJZGHZQZZLBJLSQFZGKQQJZGYCZBZQTLDXRJXBSXXPZXHYZYCLWDXJJHXMFDZPFZHQHQMQGKSLYHTYCGFRZGNQXCLPDLBZCSCZQLLJBLHBZCYPZZPPDYMZZSGYHCKCPZJGSLJLNSCDSLDLXBMSTLDDFJMKDJDHZLZXLSZQPQPGJLLYBDSZGQLBZLSLKYYHZTTNTJYQTZZPSZQZTLLJTYYLLQLLQYZQLBDZLSLYYZYMDFSZSNHLXZNCZQZPBWSKRFBSYZMTHBLGJPMCZZLSTLXSHTCSYZLZBLFEQHLXFLCJLYLJQCBZLZJHHSSTBRMHXZHJZCLXFNBGXGTQJCZTMSFZKJMSSNXLJKBHSJXNTNLZDNTLMSJXGZJYJCZXYJYJWRWWQNZTNFJSZPZSHZJFYRDJSFSZJZBJFZQZZHZLXFYSBZQLZSGYFTZDCSZXZJBQMSZKJRHYJZCKMJKHCHGTXKXQGLXPXFXTRTYLXJXHDTSJXHJZJXZWZLCQSBTXWXGXTXXHXFTSDKFJHZYJFJXRZSDLLLTQSQQZQWZXSYQTWGWBZCGZLLYZBCLMQQTZHZXZXLJFRMYZFLXYSQXXJKXRMQDZDMMYYBSQBHGZMWFWXGMXLZPYYTGZYCCDXYZXYWGSYJYZNBHPZJSQSYXSXRTFYZGRHZTXSZZTHCBFCLSYXZLZQMZLMPLMXZJXSFLBYZMYQHXJSXRXSQZZZSSLYFRCZJRCRXHHZXQYDYHXSJJHZCXZBTYNSYSXJBQLPXZQPYMLXZKYXLXCJLCYSXXZZLXDLLLJJYHZXGYJWKJRWYHCPSGNRZLFZWFZZNSXGXFLZSXZZZBFCSYJDBRJKRDHHGXJLJJTGXJXXSTJTJXLYXQFCSGSWMSBCTLQZZWLZZKXJMLTMJYHSDDBXGZHDLBMYJFRZFSGCLYJBPMLYSMSXLSZJQQHJZFXGFQFQBPXZGYYQXGZTCQWYLTLGWSGWHRLFSFGZJMGMGBGTJFSYZZGZYZAFLSSPMLPFLCWBJZCLJJMZLPJJLYMQDMYYYFBGYGYZMLYZDXQYXRQQQHSYYYQXYLJTYXFSFSLLGNQCYHYCWFHCCCFXPYLYPLLZYXXXXXKQHHXSHJZCFZSCZJXCPZWHHHHHAPYLQALPQAFYHXDYLUKMZQGGGDDESRNNZLTZGCHYPPYSQJJHCLLJTOLNJPZLJLHYMHEYDYDSQYCDDHGZUNDZCLZYZLLZNTNYZGSLHSLPJJBDGWXPCDUTJCKLKCLWKLLCASSTKZZDNQNTTLYYZSSYSSZZRYLJQKCQDHHCRXRZYDGRGCWCGZQFFFPPJFZYNAKRGYWYQPQXXFKJTSZZXSWZDDFBBXTBGTZKZNPZZPZXZPJSZBMQHKCYXYLDKLJNYPKYGHGDZJXXEAHPNZKZTZCMXCXMMJXNKSZQNMNLWBWWXJKYHCPSTMCSQTZJYXTPCTPDTNNPGLLLZSJLSPBLPLQHDTNJNLYYRSZFFJFQWDPHZDWMRZCCLODAXNSSNYZRESTYJWJYJDBCFXNMWTTBYLWSTSZGYBLJPXGLBOCLHPCBJLTMXZLJYLZXCLTPNCLCKXTPZJSWCYXSFYSZDKNTLBYJCYJLLSTGQCBXRYZXBXKLYLHZLQZLNZCXWJZLJZJNCJHXMNZZGJZZXTZJXYCYYCXXJYYXJJXSSSJSTSSTTPPGQTCSXWZDCSYFPTFBFHFBBLZJCLZZDBXGCXLQPXKFZFLSYLTUWBMQJHSZBMDDBCYSCCLDXYCDDQLYJJWMQLLCSGLJJSYFPYYCCYLTJANTJJPWYCMMGQYYSXDXQMZHSZXPFTWWZQSWQRFKJLZJQQYFBRXJHHFWJJZYQAZMYFRHCYYBYQWLPEXCCZSTYRLTTDMQLYKMBBGMYYJPRKZNPBSXYXBHYZDJDNGHPMFSGMWFZMFQMMBCMZZCJJLCNUXYQLMLRYGQZCYXZLWJGCJCGGMCJNFYZZJHYCPRRCMTZQZXHFQGTJXCCJEAQCRJYHPLQLSZDJRBCQHQDYRHYLYXJSYMHZYDWLDFRYHBPYDTSSCNWBXGLPZMLZZTQSSCPJMXXYCSJYTYCGHYCJWYRXXLFEMWJNMKLLSWTXHYYYNCMMCWJDQDJZGLLJWJRKHPZGGFLCCSCZMCBLTBHBQJXQDSPDJZZGKGLFQYWBZYZJLTSTDHQHCTCBCHFLQMPWDSHYYTQWCNZZJTLBYMBPDYYYXSQKXWYYFLXXNCWCXYPMAELYKKJMZZZBRXYYQJFLJPFHHHYTZZXSGQQMHSPGDZQWBWPJHZJDYSCQWZKTXXSQLZYYMYSDZGRXCKKUJLWPYSYSCSYZLRMLQSYLJXBCXTLWDQZPCYCYKPPPNSXFYZJJRCEMHSZMSXLXGLRWGCSTLRSXBZGBZGZTCPLUJLSLYLYMTXMTZPALZXPXJTJWTCYYZLBLXBZLQMYLXPGHDSLSSDMXMBDZZSXWHAMLCZCPJMCNHJYSNSYGCHSKQMZZQDLLKABLWJXSFMOCDXJRRLYQZKJMYBYQLYHETFJZFRFKSRYXFJTWDSXXSYSQJYSLYXWJHSNLXYYXHBHAWHHJZXWMYLJCSSLKYDZTXBZSYFDXGXZJKHSXXYBSSXDPYNZWRPTQZCZENYGCXQFJYKJBZMLJCMQQXUOXSLYXXLYLLJDZBTYMHPFSTTQQWLHOKYBLZZALZXQLHZWRRQHLSTMYPYXJJXMQSJFNBXYXYJXXYQYLTHYLQYFMLKLJTMLLHSZWKZHLJMLHLJKLJSTLQXYLMBHHLNLZXQJHXCFXXLHYHJJGBYZZKBXSCQDJQDSUJZYYHZHHMGSXCSYMXFEBCQWWRBPYYJQTYZCYQYQQZYHMWFFHGZFRJFCDPXNTQYZPDYKHJLFRZXPPXZDBBGZQSTLGDGYLCQMLCHHMFYWLZYXKJLYPQHSYWMQQGQZMLZJNSQXJQSYJYCBEHSXFSZPXZWFLLBCYYJDYTDTHWZSFJMQQYJLMQXXLLDTTKHHYBFPWTYYSQQWNQWLGWDEBZWCMYGCULKJXTMXMYJSXHYBRWFYMWFRXYQMXYSZTZZTFYKMLDHQDXWYYNLCRYJBLPSXCXYWLSPRRJWXHQYPHTYDNXHHMMYWYTZCSQMTSSCCDALWZTCPQPYJLLQZYJSWXMZZMMYLMXCLMXCZMXMZSQTZPPQQBLPGXQZHFLJJHYTJSRXWZXSCCDLXTYJDCQJXSLQYCLZXLZZXMXQRJMHRHZJBHMFLJLMLCLQNLDXZLLLPYPSYJYSXCQQDCMQJZZXHNPNXZMEKMXHYKYQLXSXTXJYYHWDCWDZHQYYBGYBCYSCFGPSJNZDYZZJZXRZRQJJYMCANYRJTLDPPYZBSTJKXXZYPFDWFGZZRPYMTNGXZQBYXNBUFNQKRJQZMJEGRZGYCLKXZDSKKNSXKCLJSPJYYZLQQJYBZSSQLLLKJXTBKTYLCCDDBLSPPFYLGYDTZJYQGGKQTTFZXBDKTYYHYBBFYTYYBCLPDYTGDHRYRNJSPTCSNYJQHKLLLZSLYDXXWBCJQSPXBPJZJCJDZFFXXBRMLAZHCSNDLBJDSZBLPRZTSWSBXBCLLXXLZDJZSJPYLYXXYFTFFFBHJJXGBYXJPMMMPSSJZJMTLYZJXSWXTYLEDQPJMYGQZJGDJLQJWJQLLSJGJGYGMSCLJJXDTYGJQJQJCJZCJGDZZSXQGSJGGCXHQXSNQLZZBXHSGZXCXYLJXYXYYDFQQJHJFXDHCTXJYRXYSQTJXYEFYYSSYYJXNCYZXFXMSYSZXYYSCHSHXZZZGZZZGFJDLTYLNPZGYJYZYYQZPBXQBDZTZCZYXXYHHSQXSHDHGQHJHGYWSZTMZMLHYXGEBTYLZKQWYTJZRCLEKYSTDBCYKQQSAYXCJXWWGSBHJYZYDHCSJKQCXSWXFLTYNYZPZCCZJQTZWJQDZZZQZLJJXLSBHPYXXPSXSHHEZTXFPTLQYZZXHYTXNCFZYYHXGNXMYWXTZSJPTHHGYMXMXQZXTSBCZYJYXXTYYZYPCQLMMSZMJZZLLZXGXZAAJZYXJMZXWDXZSXZDZXLEYJJZQBHZWZZZQTZPSXZTDSXJJJZNYAZPHXYYSRNQDTHZHYYKYJHDZXZLSWCLYBZYECWCYCRYLCXNHZYDZYDYJDFRJJHTRSQTXYXJRJHOJYNXELXSFSFJZGHPZSXZSZDZCQZBYYKLSGSJHCZSHDGQGXYZGXCHXZJWYQWGYHKSSEQZZNDZFKWYSSTCLZSTSYMCDHJXXYWEYXCZAYDMPXMDSXYBSQMJMZJMTZQLPJYQZCGQHXJHHLXXHLHDLDJQCLDWBSXFZZYYSCHTYTYYBHECXHYKGJPXHHYZJFXHWHBDZFYZBCAPNPGNYDMSXHMMMMAMYNBYJTMPXYYMCTHJBZYFCGTYHWPHFTWZZEZSBZEGPFMTSKFTYCMHFLLHGPZJXZJGZJYXZSBBQSCZZLZCCSTPGXMJSFTCCZJZDJXCYBZLFCJSYZFGSZLYBCWZZBYZDZYPSWYJZXZBDSYUXLZZBZFYGCZXBZHZFTPBGZGEJBSTGKDMFHYZZJHZLLZZGJQZLSFDJSSCBZGPDLFZFZSZYZYZSYGCXSNXXCHCZXTZZLJFZGQSQYXZJQDCCZTQCDXZJYQJQCHXZTDLGSCXZSYQJQTZWLQDQZTQCHQQJZYEZZZPBWKDJFCJPZTYPQYQTTYNLMBDKTJZPQZQZZFPZSBNJLGYJDXJDZZKZGQKXDLPZJTCJDQBXDJQJSTCKNXBXZMSLYJCQMTJQWWCJQNJNLLLHJCWQTBZQYDZCZPZZDZYDDCYZZZCCJTTJFZDPRRTZTJDCQTQZDTJNPLZBCLLCTZSXKJZQZPZLBZRBTJDCXFCZDBCCJJLTQQPLDCGZDBBZJCQDCJWYNLLZYZCCDWLLXWZLXRXNTQQCZXKQLSGDFQTDDGLRLAJJTKUYMKQLLTZYTDYYCZGJWYXDXFRSKSTQTENQMRKQZHHQKDLDAZFKYPBGGPZREBZZYKZZSPEGJXGYKQZZZSLYSYYYZWFQZYLZZLZHWCHKYPQGNPGBLPLRRJYXCCSYYHSFZFYBZYYTGZXYLXCZWXXZJZBLFFLGSKHYJZEYJHLPLLLLCZGXDRZELRHGKLZZYHZLYQSZZJZQLJZFLNBHGWLCZCFJYSPYXZLZLXGCCPZBLLCYBBBBUBBCBPCRNNZCZYRBFSRLDCGQYYQXYGMQZWTZYTYJXYFWTEHZZJYWLCCNTZYJJZDEDPZDZTSYQJHDYMBJNYJZLXTSSTPHNDJXXBYXQTZQDDTJTDYYTGWSCSZQFLSHLGLBCZPHDLYZJYCKWTYTYLBNYTSDSYCCTYSZYYEBHEXHQDTWNYGYCLXTSZYSTQMYGZAZCCSZZDSLZCLZRQXYYELJSBYMXSXZTEMBBLLYYLLYTDQYSHYMRQWKFKBFXNXSBYCHXBWJYHTQBPBSBWDZYLKGZSKYHXQZJXHXJXGNLJKZLYYCDXLFYFGHLJGJYBXQLYBXQPQGZTZPLNCYPXDJYQYDYMRBESJYYHKXXSTMXRCZZYWXYQYBMCLLYZHQYZWQXDBXBZWZMSLPDMYSKFMZKLZCYQYCZLQXFZZYDQZPZYGYJYZMZXDZFYFYTTQTZHGSPCZMLCCYTZXJCYTJMKSLPZHYSNZLLYTPZCTZZCKTXDHXXTQCYFKSMQCCYYAZHTJPCYLZLYJBJXTPNYLJYYNRXSYLMMNXJSMYBCSYSYLZYLXJJQYLDZLPQBFZZBLFNDXQKCZFYWHGQMRDSXYCYTXNQQJZYYPFZXDYZFPRXEJDGYQBXRCNFYYQPGHYJDYZXGRHTKYLNWDZNTSMPKLBTHBPYSZBZTJZSZZJTYYXZPHSSZZBZCZPTQFZMYFLYPYBBJQXZMXXDJMTSYSKKBJZXHJCKLPSMKYJZCXTMLJYXRZZQSLXXQPYZXMKYXXXJCLJPRMYYGADYSKQLSNDHYZKQXZYZTCGHZTLMLWZYBWSYCTBHJHJFCWZTXWYTKZLXQSHLYJZJXTMPLPYCGLTBZZTLZJCYJGDTCLKLPLLQPJMZPAPXYZLKKTKDZCZZBNZDYDYQZJYJGMCTXLTGXSZLMLHBGLKFWNWZHDXUHLFMKYSLGXDTWWFRJEJZTZHYDXYKSHWFZCQSHKTMQQHTZHYMJDJSKHXZJZBZZXYMPAGQMSTPXLSKLZYNWRTSQLSZBPSPSGZWYHTLKSSSWHZZLYYTNXJGMJSZSUFWNLSOZTXGXLSAMMLBWLDSZYLAKQCQCTMYCFJBSLXCLZZCLXXKSBZQCLHJPSQPLSXXCKSLNHPSFQQYTXYJZLQLDXZQJZDYYDJNZPTUZDSKJFSLJHYLZSQZLBTXYDGTQFDBYAZXDZHZJNHHQBYKNXJJQCZMLLJZKSPLDYCLBBLXKLELXJLBQYCXJXGCNLCQPLZLZYJTZLJGYZDZPLTQCSXFDMNYCXGBTJDCZNBGBQYQJWGKFHTNPYQZQGBKPBBYZMTJDYTBLSQMPSXTBNPDXKLEMYYCJYNZCTLDYKZZXDDXHQSHDGMZSJYCCTAYRZLPYLTLKXSLZCGGEXCLFXLKJRTLQJAQZNCMBYDKKCXGLCZJZXJHPTDJJMZQYKQSECQZDSHHADMLZFMMZBGNTJNNLGBYJBRBTMLBYJDZXLCJLPLDLPCQDHLXZLYCBLCXZZJADJLNZMMSSSMYBHBSQKBHRSXXJMXSDZNZPXLGBRHWGGFCXGMSKLLTSJYYCQLTSKYWYYHYWXBXQYWPYWYKQLSQPTNTKHQCWDQKTWPXXHCPTHTWUMSSYHBWCRWXHJMKMZNGWTMLKFGHKJYLSYYCXWHYECLQHKQHTTQKHFZLDXQWYZYYDESBPKYRZPJFYYZJCEQDZZDLATZBBFJLLCXDLMJSSXEGYGSJQXCWBXSSZPDYZCXDNYXPPZYDLYJCZPLTXLSXYZYRXCYYYDYLWWNZSAHJSYQYHGYWWAXTJZDAXYSRLTDPSSYYFNEJDXYZHLXLLLZQZSJNYQYQQXYJGHZGZCYJCHZLYCDSHWSHJZYJXCLLNXZJJYYXNFXMWFPYLCYLLABWDDHWDXJMCXZTZPMLQZHSFHZYNZTLLDYWLSLXHYMMYLMBWWKYXYADTXYLLDJPYBPWUXJMWMLLSAFDLLYFLBHHHBQQLTZJCQJLDJTFFKMMMBYTHYGDCQRDDWRQJXNBYSNWZDBYYTBJHPYBYTTJXAAHGQDQTMYSTQXKBTZPKJLZRBEQQSSMJJBDJOTGTBXPGBKTLHQXJJJCTHXQDWJLWRFWQGWSHCKRYSWGFTGYGBXSDWDWRFHWYTJJXXXJYZYSLPYYYPAYXHYDQKXSHXYXGSKQHYWFDDDPPLCJLQQEEWXKSYYKDYPLTJTHKJLTCYYHHJTTPLTZZCDLTHQKZXQYSTEEYWYYZYXXYYSTTJKLLPZMCYHQGXYHSRMBXPLLNQYDQHXSXXWGDQBSHYLLPJJJTHYJKYPPTHYYKTYEZYENMDSHLCRPQFDGFXZPSFTLJXXJBSWYYSKSFLXLPPLBBBLBSFXFYZBSJSSYLPBBFFFFSSCJDSTZSXZRYYSYFFSYZYZBJTBCTSBSDHRTJJBYTCXYJEYLXCBNEBJDSYXYKGSJZBXBYTFZWGENYHHTHZHHXFWGCSTBGXKLSXYWMTMBYXJSTZSCDYQRCYTWXZFHMYMCXLZNSDJTTTXRYCFYJSBSDYERXJLJXBBDEYNJGHXGCKGSCYMBLXJMSZNSKGXFBNBPTHFJAAFXYXFPXMYPQDTZCXZZPXRSYWZDLYBBKTYQPQJPZYPZJZNJPZJLZZFYSBTTSLMPTZRTDXQSJEHBZYLZDHLJSQMLHTXTJECXSLZZSPKTLZKQQYFSYGYWPCPQFHQHYTQXZKRSGTTSQCZLPTXCDYYZXSQZSLXLZMYCPCQBZYXHBSXLZDLTCDXTYLZJYYZPZYZLTXJSJXHLPMYTXCQRBLZSSFJZZTNJYTXMYJHLHPPLCYXQJQQKZZSCPZKSWALQSBLCCZJSXGWWWYGYKTJBBZTDKHXHKGTGPBKQYSLPXPJCKBMLLXDZSTBKLGGQKQLSBKKTFXRMDKBFTPZFRTBBRFERQGXYJPZSSTLBZTPSZQZSJDHLJQLZBPMSMMSXLQQNHKNBLRDDNXXDHDDJCYYGYLXGZLXSYGMQQGKHBPMXYXLYTQWLWGCPBMQXCYZYDRJBHTDJYHQSHTMJSBYPLWHLZFFNYPMHXXHPLTBQPFBJWQDBYGPNZTPFZJGSDDTQSHZEAWZZYLLTYYBWJKXXGHLFKXDJTMSZSQYNZGGSWQSPHTLSSKMCLZXYSZQZXNCJDQGZDLFNYKLJCJLLZLMZZNHYDSSHTHZZLZZBBHQZWWYCRZHLYQQJBEYFXXXWHSRXWQHWPSLMSSKZTTYGYQQWRSLALHMJTQJSMXQBJJZJXZYZKXBYQXBJXSHZTSFJLXMXZXFGHKZSZGGYLCLSARJYHSLLLMZXELGLXYDJYTLFBHBPNLYZFBBHPTGJKWETZHKJJXZXXGLLJLSTGSHJJYQLQZFKCGNNDJSSZFDBCTWWSEQFHQJBSAQTGYPQLBXBMMYWXGSLZHGLZGQYFLZBYFZJFRYSFMBYZHQGFWZSYFYJJPHZBYYZFFWODGRLMFTWLBZGYCQXCDJYGZYYYYTYTYDWEGAZYHXJLZYYHLRMGRXXZCLHNELJJTJTPWJYBJJBXJJTJTEEKHWSLJPLPSFYZPQQBDLQJJTYYQLYZKDKSQJYYQZLDQTGJQYZJSUCMRYQTHTEJMFCTYHYPKMHYZWJDQFHYYXWSHCTXRLJHQXHCCYYYJLTKTTYTMXGTCJTZAYYOCZLYLBSZYWJYTSJYHBYSHFJLYGJXXTMZYYLTXXYPZLXYJZYZYYPNHMYMDYYLBLHLSYYQQLLNJJYMSOYQBZGDLYXYLCQYXTSZEGXHZGLHWBLJHEYXTWQMAKBPQCGYSHHEGQCMWYYWLJYJHYYZLLJJYLHZYHMGSLJLJXCJJYCLYCJPCPZJZJMMYLCQLNQLJQJSXYJMLSZLJQLYCMMHCFMMFPQQMFYLQMCFFQMMMMHMZNFHHJGTTHHKHSLNCHHYQDXTMMQDCYZYXYQMYQYLTDCYYYZAZZCYMZYDLZFFFMMYCQZWZZMABTBYZTDMNZZGGDFTYPCGQYTTSSFFWFDTZQSSYSTWXJHXYTSXXYLBYQHWWKXHZXWZNNZZJZJJQJCCCHYYXBZXZCYZTLLCQXYNJYCYYCYNZZQYYYEWYCZDCJYCCHYJLBTZYYCQWMPWPYMLGKDLDLGKQQBGYCHJXY";
    var oMultiDiff = {
      "19969": "DZ",
      "19975": "WM",
      "19988": "QJ",
      "20048": "YL",
      "20056": "SC",
      "20060": "NM",
      "20094": "QG",
      "20127": "QJ",
      "20167": "QC",
      "20193": "YG",
      "20250": "KH",
      "20256": "ZC",
      "20282": "SC",
      "20285": "QJG",
      "20291": "TD",
      "20314": "YD",
      "20340": "NE",
      "20375": "TD",
      "20389": "YJ",
      "20391": "CZ",
      "20415": "PB",
      "20446": "YS",
      "20447": "SQ",
      "20504": "TC",
      "20608": "KG",
      "20854": "QJ",
      "20857": "ZC",
      "20911": "PF",
      "20504": "TC",
      "20608": "KG",
      "20854": "QJ",
      "20857": "ZC",
      "20911": "PF",
      "20985": "AW",
      "21032": "PB",
      "21048": "XQ",
      "21049": "SC",
      "21089": "YS",
      "21119": "JC",
      "21242": "SB",
      "21273": "SC",
      "21305": "YP",
      "21306": "QO",
      "21330": "ZC",
      "21333": "SDC",
      "21345": "QK",
      "21378": "CA",
      "21397": "SC",
      "21414": "XS",
      "21442": "SC",
      "21477": "JG",
      "21480": "TD",
      "21484": "ZS",
      "21494": "YX",
      "21505": "YX",
      "21512": "HG",
      "21523": "XH",
      "21537": "PB",
      "21542": "PF",
      "21549": "KH",
      "21571": "E",
      "21574": "DA",
      "21588": "TD",
      "21589": "O",
      "21618": "ZC",
      "21621": "KHA",
      "21632": "ZJ",
      "21654": "KG",
      "21679": "LKG",
      "21683": "KH",
      "21710": "A",
      "21719": "YH",
      "21734": "WOE",
      "21769": "A",
      "21780": "WN",
      "21804": "XH",
      "21834": "A",
      "21899": "ZD",
      "21903": "RN",
      "21908": "WO",
      "21939": "ZC",
      "21956": "SA",
      "21964": "YA",
      "21970": "TD",
      "22003": "A",
      "22031": "JG",
      "22040": "XS",
      "22060": "ZC",
      "22066": "ZC",
      "22079": "MH",
      "22129": "XJ",
      "22179": "XA",
      "22237": "NJ",
      "22244": "TD",
      "22280": "JQ",
      "22300": "YH",
      "22313": "XW",
      "22331": "YQ",
      "22343": "YJ",
      "22351": "PH",
      "22395": "DC",
      "22412": "TD",
      "22484": "PB",
      "22500": "PB",
      "22534": "ZD",
      "22549": "DH",
      "22561": "PB",
      "22612": "TD",
      "22771": "KQ",
      "22831": "HB",
      "22841": "JG",
      "22855": "QJ",
      "22865": "XQ",
      "23013": "ML",
      "23081": "WM",
      "23487": "SX",
      "23558": "QJ",
      "23561": "YW",
      "23586": "YW",
      "23614": "YW",
      "23615": "SN",
      "23631": "PB",
      "23646": "ZS",
      "23663": "ZT",
      "23673": "YG",
      "23762": "TD",
      "23769": "ZS",
      "23780": "QJ",
      "23884": "QK",
      "24055": "XH",
      "24113": "DC",
      "24162": "ZC",
      "24191": "GA",
      "24273": "QJ",
      "24324": "NL",
      "24377": "TD",
      "24378": "QJ",
      "24439": "PF",
      "24554": "ZS",
      "24683": "TD",
      "24694": "WE",
      "24733": "LK",
      "24925": "TN",
      "25094": "ZG",
      "25100": "XQ",
      "25103": "XH",
      "25153": "PB",
      "25170": "PB",
      "25179": "KG",
      "25203": "PB",
      "25240": "ZS",
      "25282": "FB",
      "25303": "NA",
      "25324": "KG",
      "25341": "ZY",
      "25373": "WZ",
      "25375": "XJ",
      "25384": "A",
      "25457": "A",
      "25528": "SD",
      "25530": "SC",
      "25552": "TD",
      "25774": "ZC",
      "25874": "ZC",
      "26044": "YW",
      "26080": "WM",
      "26292": "PB",
      "26333": "PB",
      "26355": "ZY",
      "26366": "CZ",
      "26397": "ZC",
      "26399": "QJ",
      "26415": "ZS",
      "26451": "SB",
      "26526": "ZC",
      "26552": "JG",
      "26561": "TD",
      "26588": "JG",
      "26597": "CZ",
      "26629": "ZS",
      "26638": "YL",
      "26646": "XQ",
      "26653": "KG",
      "26657": "XJ",
      "26727": "HG",
      "26894": "ZC",
      "26937": "ZS",
      "26946": "ZC",
      "26999": "KJ",
      "27099": "KJ",
      "27449": "YQ",
      "27481": "XS",
      "27542": "ZS",
      "27663": "ZS",
      "27748": "TS",
      "27784": "SC",
      "27788": "ZD",
      "27795": "TD",
      "27812": "O",
      "27850": "PB",
      "27852": "MB",
      "27895": "SL",
      "27898": "PL",
      "27973": "QJ",
      "27981": "KH",
      "27986": "HX",
      "27994": "XJ",
      "28044": "YC",
      "28065": "WG",
      "28177": "SM",
      "28267": "QJ",
      "28291": "KH",
      "28337": "ZQ",
      "28463": "TL",
      "28548": "DC",
      "28601": "TD",
      "28689": "PB",
      "28805": "JG",
      "28820": "QG",
      "28846": "PB",
      "28952": "TD",
      "28975": "ZC",
      "29100": "A",
      "29325": "QJ",
      "29575": "SL",
      "29602": "FB",
      "30010": "TD",
      "30044": "CX",
      "30058": "PF",
      "30091": "YSP",
      "30111": "YN",
      "30229": "XJ",
      "30427": "SC",
      "30465": "SX",
      "30631": "YQ",
      "30655": "QJ",
      "30684": "QJG",
      "30707": "SD",
      "30729": "XH",
      "30796": "LG",
      "30917": "PB",
      "31074": "NM",
      "31085": "JZ",
      "31109": "SC",
      "31181": "ZC",
      "31192": "MLB",
      "31293": "JQ",
      "31400": "YX",
      "31584": "YJ",
      "31896": "ZN",
      "31909": "ZY",
      "31995": "XJ",
      "32321": "PF",
      "32327": "ZY",
      "32418": "HG",
      "32420": "XQ",
      "32421": "HG",
      "32438": "LG",
      "32473": "GJ",
      "32488": "TD",
      "32521": "QJ",
      "32527": "PB",
      "32562": "ZSQ",
      "32564": "JZ",
      "32735": "ZD",
      "32793": "PB",
      "33071": "PF",
      "33098": "XL",
      "33100": "YA",
      "33152": "PB",
      "33261": "CX",
      "33324": "BP",
      "33333": "TD",
      "33406": "YA",
      "33426": "WM",
      "33432": "PB",
      "33445": "JG",
      "33486": "ZN",
      "33493": "TS",
      "33507": "QJ",
      "33540": "QJ",
      "33544": "ZC",
      "33564": "XQ",
      "33617": "YT",
      "33632": "QJ",
      "33636": "XH",
      "33637": "YX",
      "33694": "WG",
      "33705": "PF",
      "33728": "YW",
      "33882": "SR",
      "34067": "WM",
      "34074": "YW",
      "34121": "QJ",
      "34255": "ZC",
      "34259": "XL",
      "34425": "JH",
      "34430": "XH",
      "34485": "KH",
      "34503": "YS",
      "34532": "HG",
      "34552": "XS",
      "34558": "YE",
      "34593": "ZL",
      "34660": "YQ",
      "34892": "XH",
      "34928": "SC",
      "34999": "QJ",
      "35048": "PB",
      "35059": "SC",
      "35098": "ZC",
      "35203": "TQ",
      "35265": "JX",
      "35299": "JX",
      "35782": "SZ",
      "35828": "YS",
      "35830": "E",
      "35843": "TD",
      "35895": "YG",
      "35977": "MH",
      "36158": "JG",
      "36228": "QJ",
      "36426": "XQ",
      "36466": "DC",
      "36710": "JC",
      "36711": "ZYG",
      "36767": "PB",
      "36866": "SK",
      "36951": "YW",
      "37034": "YX",
      "37063": "XH",
      "37218": "ZC",
      "37325": "ZC",
      "38063": "PB",
      "38079": "TD",
      "38085": "QY",
      "38107": "DC",
      "38116": "TD",
      "38123": "YD",
      "38224": "HG",
      "38241": "XTC",
      "38271": "ZC",
      "38415": "YE",
      "38426": "KH",
      "38461": "YD",
      "38463": "AE",
      "38466": "PB",
      "38477": "XJ",
      "38518": "YT",
      "38551": "WK",
      "38585": "ZC",
      "38704": "XS",
      "38739": "LJ",
      "38761": "GJ",
      "38808": "SQ",
      "39048": "JG",
      "39049": "XJ",
      "39052": "HG",
      "39076": "CZ",
      "39271": "XT",
      "39534": "TD",
      "39552": "TD",
      "39584": "PB",
      "39647": "SB",
      "39730": "LG",
      "39748": "TPB",
      "40109": "ZQ",
      "40479": "ND",
      "40516": "HG",
      "40536": "HG",
      "40583": "QJ",
      "40765": "YQ",
      "40784": "QJ",
      "40840": "YK",
      "40863": "QJG"
    };
    var getMnemonicCode = function (str) {
      if (typeof (str) != "string")
        throw new Error(-1, "门店名称类型不合法!");
      var arrResult = new Array();
      //将字符串转码后转为数组
      for (var i = 0, len = str.length; i < len; i++) {
        var ch = str.charAt(i);
        arrResult.push(checkCh(ch));
      }
      return mkRslt(arrResult);
    }

    var checkCh = function (ch) {
      var uni = ch.charCodeAt(0);
      //如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
      if (uni > 40869 || uni < 19968) {
        return ch; //dealWithOthers(ch);
      }
      //检查是否是多音字,是按多音字处理,不是就直接在strChineseFirstPY字符串中找对应的首字母
      return (oMultiDiff[uni] ? oMultiDiff[uni] : (strChineseFirstPY.charAt(uni - 19968)));
    }

    var mkRslt = function (arr) {
      var arrRslt = [""];
      for (var i = 0, len = arr.length; i < len; i++) {
        var str = arr[i];
        var strlen = str.length;
        if (strlen == 1) {
          for (var k = 0; k < arrRslt.length; k++) {
            arrRslt[k] += str;
          }
        } else {
          var tmpArr = arrRslt.slice(0);
          arrRslt = [];
          for (k = 0; k < strlen; k++) {
            //复制一个相同的arrRslt
            var tmp = tmpArr.slice(0);
            //把当前字符str[k]添加到每个元素末尾
            for (var j = 0; j < tmp.length; j++) {
              tmp[j] += str.charAt(k);
            }
            //把复制并修改后的数组连接到arrRslt上
            arrRslt = arrRslt.concat(tmp);
          }
        }
      }
      return arrRslt;
    }

    return {
      initRegionAndPosition: initRegionAndPosition,
      bacthnoAndExpiryDateManage: bacthnoAndExpiryDateManage,
      getMnemonicCode: getMnemonicCode,
      initBarcodeModel: initBarcodeModel,
      onBarCodeEnter: onBarCodeEnter
    }
  }();
  try {
    module.exports = common_VM_Extend;
  } catch (error) { }
  return common_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/common/common_VM.Extend.js